"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "pickTaskFromQueue", {
    enumerable: true,
    get: function() {
        return pickTaskFromQueue;
    }
});
function isBetterCandidateThanCurrent(current, candidate) {
    // If we don't have any current candidates, the new candidate is better by definition
    if (!current) {
        return true;
    }
    // If the new candidate has a higher priority than the current candidate, it is better
    if (candidate.priority && (current.priority == undefined || candidate.priority > current.priority)) {
        return true;
    }
    // Otherwise stick with the current candidate
    return false;
}
function pickTaskFromQueue(queue, availability) {
    let maxPrioritySeenSoFar = undefined;
    let bestCandidateTask = undefined;
    for(let i = 0; i < queue.length; i++){
        const taskToConsider = queue[i];
        // A task is not a candidate if there is not enough availability to run it
        if (taskToConsider.weight <= availability) {
            // If we have enough availability and there have been no higher priority tasks before this one, we can execute this task;
            if (isBetterCandidateThanCurrent(bestCandidateTask?.queueItem, taskToConsider)) {
                bestCandidateTask = {
                    queueItem: taskToConsider,
                    index: i
                };
            }
        }
        if (taskToConsider.priority !== undefined) {
            maxPrioritySeenSoFar = maxPrioritySeenSoFar !== undefined ? Math.max(maxPrioritySeenSoFar, taskToConsider.priority) : taskToConsider.priority;
        }
    }
    // Confirm the candidate task has a priority equal to the highest priority seen across all tasks
    if (bestCandidateTask && (maxPrioritySeenSoFar === undefined || bestCandidateTask.queueItem.priority === maxPrioritySeenSoFar)) {
        return bestCandidateTask.index;
    }
    return -1;
}
